import styled from 'styled-components';

import FilterUser from 'components/orders/Filters/Filters/Users/container';

export default styled(FilterUser)`
  & > div > div:first-child {
    background-color: transparent;
  }
  span + div {
    background-color: transparent;
  }
  div[class$='placeholder'] {
    color: var(--primary500);
  }
  div[class$='single-value'] {
    color: var(--primary500);
  }
  div[class$='indicators'] svg {
    fill: var(--primary500);
  }
`;
